import React from "react";

export const AwardEmployeeIcon = () => {

    return (
    <svg width="71" height="54" viewBox="0 0 71 54" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1326_2074)">
    <rect x="19.25" y="11" width="32" height="32" rx="16" stroke="#FF9E00" strokeWidth="2"/>
    </g>
    <g clipPath="url(#clip0_1326_2074)">
    <path d="M28.5833 35.3333C28.5833 33.5652 29.2857 31.8695 30.536 30.6193C31.7862 29.369 33.4819 28.6666 35.25 28.6666C36.164 28.6666 37.0586 28.8543 37.8824 29.2084L37.25 30.7507C36.6251 30.478 35.945 30.3333 35.25 30.3333C33.9239 30.3333 32.6522 30.8601 31.7145 31.7978C30.7768 32.7355 30.25 34.0072 30.25 35.3333H28.5833ZM35.25 27.8333C32.4875 27.8333 30.25 25.5958 30.25 22.8333C30.25 20.0708 32.4875 17.8333 35.25 17.8333C38.0125 17.8333 40.25 20.0708 40.25 22.8333C40.25 25.5958 38.0125 27.8333 35.25 27.8333ZM35.25 26.1666C37.0917 26.1666 38.5833 24.675 38.5833 22.8333C38.5833 20.9916 37.0917 19.5 35.25 19.5C33.4083 19.5 31.9167 20.9916 31.9167 22.8333C31.9167 24.675 33.4083 26.1666 35.25 26.1666Z" fill="#FF9E00"/>
    <path d="M39.6867 32.2746L40.75 31.4679L41.8088 32.2746L41.4054 30.9684L42.4688 30.125H41.1671L40.75 28.8371L40.3329 30.125H39.0313L40.09 30.9684L39.6867 32.2746ZM44.4167 30.5834C44.4167 28.5575 42.7758 26.9167 40.75 26.9167C38.7242 26.9167 37.0833 28.5575 37.0833 30.5834C37.0833 31.5138 37.4317 32.3571 38 33.0034V36.5417L40.75 35.625L43.5 36.5417V33.0034C44.0683 32.3571 44.4167 31.5138 44.4167 30.5834ZM40.75 27.8334C42.2671 27.8334 43.5 29.0663 43.5 30.5834C43.5 32.1004 42.2671 33.3334 40.75 33.3334C39.2329 33.3334 38 32.1004 38 30.5834C38 29.0663 39.2329 27.8334 40.75 27.8334Z" fill="#FF9E00"/>
    </g>
    <defs>
    <filter id="filter0_d_1326_2074" x="0.25" y="-2" width="70" height="70" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
    <feOffset dy="6"/>
    <feGaussianBlur stdDeviation="9"/>
    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1326_2074"/>
    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1326_2074" result="shape"/>
    </filter>
    <clipPath id="clip0_1326_2074">
    <rect width="20" height="20" fill="white" transform="translate(25.25 17)"/>
    </clipPath>
    </defs>
    </svg>

    )
  };





